module.exports = __webpack_public_path__ + "media/tr.5992d9af.mp3";